<template>
    <Home fit="cover">  <!-- andere Option "Contain" -->
        <template #picture>
            <!-- background -->
            <source media="(orientation: portrait)" srcset="../assets/img/zdf_logo_phonePortrait.png">
            <source media="(orientation: landscape)" srcset="../assets/img/zdf_logo_phoneLandscape.png">
        </template>
        <template #headline>Trump und das Weiße Haus</template>
        <template #subline>Erkunden Sie die Umbaumaßnahmen</template>
        <template #text>
        </template>
        <template #update>
            30.05.2026
        </template>
    </Home>
</template>

<script>
    export default {
        name: 'home',
        babylonState: {
            //-- Kamera --
            camera:  {
                position: [.5 * Math.PI, .45 * Math.PI, 9],
                target: [0, 1.5, 0],
            },

            //-- Models --
            Karten: {
                visible:true,

                Karte_all: {visible: false},
                Karte_ostfluegel: {visible: false},
                Karte_weissesHaus: {visible: true},
                Karte_ostfluegel_transparent: {visible: false},
            },
            
            WeissesHaus: {visible:true},
            Ostfluegel_alt: {visible:true},
            Ostfluegel: {visible:false},
        },
        
        babylonReady: function ()
        {
            this.$babylonController.setVisibility("Ostfluegel_alt", 1);
            this.$babylonController.setAutoRotateBehaviour(true);

            //-- Anfangszustand --
            this.$babylonController.setVisibility("WeissesHaus", 1);
            this.$babylonController.setVisibility("WeissesHaus_Shadow", 1);
            this.$babylonController.setVisibility("Ostfluegel_alt", 1);
            this.$babylonController.setEnable("Ostfluegel_alt", true);
            this.$babylonController.setVisibility("Ostfluegel_alt_shadow", 1);
            this.$babylonController.setVisibility("Karte_weissesHaus", 1);
        },
        // methods: {
        //     next: function () {
        //         this.$tracking.navigationClick('Start');
        //         this.$eventBus.$emit('nextPage');
        //     }
        // },
    }
</script>

<style lang="scss">

    .home {

        // change default opacity: 0.35
        .home__background {

            opacity: 0;
        }
        // change default object-position: unset (50% 50%)  / Für Portrait ist nur der x-Wert relevant, für Landscape nur der y-Wert. / Einheit entweder in "%" oder "px"
        .home__background img.o-fit {

            //object-position: 50% 0%;
            //
            //@media (orientation: landscape) {
            //
            //    object-position: 0% 50%;
            //}
        }
    }

</style>
